import { render, staticRenderFns } from "./CoMyEvents.vue?vue&type=template&id=35d32c70&"
import script from "./CoMyEvents.vue?vue&type=script&lang=ts&"
export * from "./CoMyEvents.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports